if (!customElements.get("quantity-swatch")) {
  class QuantitySwatch extends HTMLElement {
    selectors = {
      priceWrapper: '[quantity-swatch="price-wrapper"]',
      priceWrapperSC: '[quantity-swatch="sc-price-wrapper"]',
      fullPriceWrapperSC: '[quantity-swatch="sc-full-price-wrapper"]',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.quantity = Number(this.getAttribute("data-quantity"));
      this.priceString = this.getAttribute("data-price-string") || "";
      this.priceWrapper = this.querySelector(this.selectors.priceWrapper);
      this.priceWrapperSC = this.querySelector(this.selectors.priceWrapperSC);
      this.fullPriceWrapperSC = this.querySelector(this.selectors.fullPriceWrapperSC);
    }

    updatePrice(totalPrice) {
      if (!totalPrice || !this.quantity) {
        this.priceWrapper?.classList.add("hidden");
        return;
      }

      const piecePrice = Math.round(totalPrice / this.quantity);
      const formattedPrice = formatMoney(piecePrice);

      if (formattedPrice && this.priceWrapper) {
        this.priceWrapper.innerHTML = `${formattedPrice}${this.priceString}`;
      }

      if (formattedPrice && this.priceWrapperSC) {
        this.priceWrapperSC.innerHTML = `${formattedPrice} ${this.priceString}`;
      }

      if (totalPrice && this.fullPriceWrapperSC) {
        this.fullPriceWrapperSC.innerHTML = formatMoney(totalPrice);
      }
    }
  }
  customElements.define("quantity-swatch", QuantitySwatch);
}
